import clsx from "classnames";
import { Description, Title } from "@/ui";
import classes from "../styles.module.scss";

/**
 * Heading and intro copy shown above the title bar.
 *
 * @param {string} [title] - Section heading.
 * @param {string} [titleColor] - Text colour class for the heading.
 * @param {string} [description] - Intro rich text under the heading.
 * @param {string} [textColor] - Text colour class for the intro copy.
 * @param {string} [alignment] - Text alignment class for the heading and intro copy.
 * @returns {JSX.Element|null}
 */
export default function FAQIntro({ title, titleColor, description, textColor, alignment }) {
  if (!title && !description) return null;

  return (
    <div className={clsx(classes.faq__intro, alignment)}>
      <div data-sourceflow-prop="title">
        <Title title={title} tag="h2" className={clsx("mb-3", titleColor)} />
      </div>
      <div data-sourceflow-prop="description" className={textColor}>
        <Description description={description} className="mb-0" />
      </div>
    </div>
  );
}
